import { useEffect, useRef, useState } from "react";
import useOutsideClick from "../../../hook/useOutsideClick";
import { fetchAllFurnitureLeaseQuery, generateLeasePDFQuery } from '../../../api/services/leaseProtectionPolicy.service';
import useApi from "../../../hook/useApi";
import { TOAST_TIME } from "../../../constants/toastNotifications";
import toast from "react-hot-toast";

export const useLeaseProtectionListing = () => {
    const actionMenuRef = useRef(null);
    const [isViewContractModal, setIsViewContractModal] = useState(false);
    const [toggleActionMenu, setToggleActionMenu] = useState(null);
    const [currentTab, setCurrentTab] = useState('coverages');
    const [leaseProtectionCoverages, setLeaseProtectionCoverages] = useState([]);
    const [contractAttachemnts, setContractAttachemnts] = useState([]);
    const [leaseProtectionActionClickedData, setLeaseProtectionActionClickedData] = useState(null);
    const [leaseProtectionActionClickedId, setLeaseProtectionActionClickedId] = useState(null);

    const [getLeaseData, loading] = useApi(fetchAllFurnitureLeaseQuery);
    const [generateLeasePdf, generateLoading] = useApi(generateLeasePDFQuery);

    useOutsideClick(actionMenuRef, () => setToggleActionMenu(false));

    const handleActionClick = (e, data) => {
        e.stopPropagation();
        setLeaseProtectionActionClickedId(parseInt(data?.id));
        setLeaseProtectionActionClickedData(data);

        toggleActionMenu ? setToggleActionMenu(null) : setToggleActionMenu(data.id);
    };

    const handleDownload = async (attachmentLink) => {
        if (attachmentLink) {
            window.open(attachmentLink, '_blank');
        }
    }

    const handleDownloadCertificate = async (id) => {
        const { data, errors } = await generateLeasePdf(parseInt(id));
        if (data) {
            const url = data.FurnitureLeaseInvoice.url;
            window.open(url, "_blank")
            console.log(url, 'url')
        } else {
            console.log(errors, 'errors')
            toast.error('Failed to generate certificate.', { duration: TOAST_TIME });
        }
    }

    const handleViewContract = (attachmentLink) => {
        setIsViewContractModal(true);
        console.log('attachmentLink', attachmentLink)
        setContractAttachemnts({ location: attachmentLink });
    }

    const fetchLeases = async () => {
        const user = JSON.parse(localStorage.getItem('login-user'));
        if (!user?.entityId) return;
        const { data, errors } = await getLeaseData(user.entityId);
        if (data) {
            const coverages = data?.findAllFurnitureLease?.map((item, i) => {
                const attachments = JSON.parse(item?.attachments);
                return {
                    ...item,
                    key: i + 1,
                    id: i + 1,
                    address: item?.address || 'NA',
                    mailingAddress: item?.mailingAddress || 'NA',
                    startDate: item?.startDate || 'NA',
                    endDate: item?.endDate || 'NA',
                    totalValue: item?.totalValue || 'NA',
                    premium: item?.premium || 'NA',
                    email: item?.customer?.email || 'NA',
                    phoneNumber: item?.customer?.phoneNumber || 'NA',
                    coverageAttachments: item.attachments,
                    attachments: attachments[0]?.map(item => item.location) || 'NA',
                    refNo: item?.leaseNo || 'NA',
                    furnitureType: item?.furnitureType || 'NA',
                    name: item?.customer ? `${item?.customer?.firstName} ${item?.customer?.lastName}` : 'NA',
                }
            });
            setLeaseProtectionCoverages(coverages);
        } else {
            toast.error('Failed to fetch lease protection coverages.', { duration: TOAST_TIME });
        }
    };

    useEffect(() => {
        fetchLeases();
    }, [])

    return {
        loading: loading || generateLoading,
        leaseProtectionCoverages,
        leaseProtectionActionClickedData,
        leaseProtectionActionClickedId,
        actionMenuRef,
        toggleActionMenu,
        contractAttachemnts,
        handleActionClick,
        currentTab, setCurrentTab,
        isViewContractModal,
        handleViewContract,
        setIsViewContractModal,
        handleDownload,
        handleDownloadCertificate
    }
}